/** The calendar month end represented by a validated depreciation period. */
export function depreciationPeriodEndDate(period) {
    const year = Number(period.slice(0, 4));
    const month = Number(period.slice(5, 7));
    return new Date(Date.UTC(year, month, 0)).toISOString().slice(0, 10);
}
